import PropTypes from "prop-types";
import styled from "styled-components";

import Loading from "@/components/core/layout/loading";

import Hint from "../Hint";
import Icon from "../Icon";
import { DimTestConfig } from ".";

const WarningPanel = styled.div`
    display: flex;
    align-items: center;
    background-color: #fff3cd;
    color: #664d03;
    border-radius: 10px;
    padding: 1em;
    border: 1px solid #ffecb5;
    margin-bottom: 1em;
`;

const WarningIcon = styled(Icon)`
    cursor: unset;
    font-size: 2em;
    margin-right: 0.5em;
`;

const DimTestContent = styled.div`
    text-align: center;
    margin: 2em auto;
`;

const LightLevelSlider = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1em;
`;

const LightLevelText = styled(Hint)`
    margin-right: 0.5em;
    min-width: 50px;
`;

/**
 * Dim test confirmation and loading dialog with a light level slider.
 *
 * @param root0 - The component props.
 * @param root0.setDimTestState - Callback to update the dim test state.
 * @param root0.dimTestState - The current dim test state.
 * @param root0.onConfirmDimTest - Callback when the dim test is confirmed.
 * @param root0.dimTestGroup - The group being dim tested.
 * @param root0.setDimTestLightLevel - Callback to set the dim test light level.
 * @param root0.dimTestLightLevel - The current dim test light level.
 * @returns The rendered dim test loading dialog.
 */
const DimTestLoading = ({
    setDimTestState,
    dimTestState,
    onConfirmDimTest,
    dimTestGroup,
    setDimTestLightLevel,
    dimTestLightLevel,
}) => (
    <Loading
        type={
            dimTestState === DimTestConfig.states.confirm ? "dialog" : "spinner"
        }
        onConfirm={onConfirmDimTest}
        onDeny={() => setDimTestState(null)}
        confirmText={DimTestConfig.text.confirm.buttons.confirm}
        denyText={DimTestConfig.text.confirm.buttons.deny}
        message={
            dimTestState === DimTestConfig.states.loading
                ? DimTestConfig.text.loading
                : null
        }
    >
        {dimTestState === DimTestConfig.states.confirm && (
            <>
                <WarningPanel>
                    <WarningIcon className="fa fa-info-circle" />
                    <div>{DimTestConfig.text.confirm.warning}</div>
                </WarningPanel>
                <DimTestContent>
                    <h2>Dim {dimTestGroup.groupName}</h2>
                    <Hint>{DimTestConfig.text.confirm.testDuration}</Hint>
                    <LightLevelSlider>
                        <LightLevelText>{dimTestLightLevel}%</LightLevelText>
                        <input
                            id="lightLevel"
                            type="range"
                            min="0"
                            max="100"
                            step="1"
                            value={dimTestLightLevel}
                            onChange={(e) =>
                                setDimTestLightLevel(
                                    parseInt(e.target.value, 10),
                                )
                            }
                        />
                    </LightLevelSlider>
                </DimTestContent>
            </>
        )}
    </Loading>
);

DimTestLoading.propTypes = {
    setDimTestState: PropTypes.func.isRequired,
    dimTestState: PropTypes.string.isRequired,
    onConfirmDimTest: PropTypes.func.isRequired,
    dimTestGroup: PropTypes.object.isRequired,
    setDimTestLightLevel: PropTypes.func.isRequired,
    dimTestLightLevel: PropTypes.number.isRequired,
};

export default DimTestLoading;
